module.exports = __webpack_public_path__ + "static/media/icon-mos.70ec5207.svg";